import { useMemo } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import geoData from "@/data/us-states.json";

// active = has >=1 Active chapter (red glow)
// wanted = has Forming chapter(s) but no Active (amber pulse)
// none   = no chapters (muted, still clickable)
const COLORS = {
  active: "#D90429",
  wanted: "#F4A261",
  none: "#1a2547",
};

export const ChapterMap = ({ chapters = [], selected = "", onSelect }) => {
  const statusByState = useMemo(() => {
    const map = {};
    for (const c of chapters) {
      const s = (c.state || "").trim();
      if (!s) continue;
      const cur = map[s];
      if ((c.status || "Active") === "Active") map[s] = "active";
      else if (cur !== "active") map[s] = "wanted";
    }
    return map;
  }, [chapters]);

  return (
    <div data-testid="chapter-map" className="max-w-4xl mx-auto">
      <ComposableMap
        projection="geoAlbersUsa"
        projectionConfig={{ scale: 1000 }}
        width={975}
        height={520}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography={geoData}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const name = geo.properties.name;
              const status = statusByState[name] || "none";
              const isSel = selected && selected.toLowerCase() === name.toLowerCase();
              const cls = `chapter-state ${status === "active" ? "chapter-state-active" : ""} ${status === "wanted" ? "chapter-state-wanted" : ""}`;
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  onClick={() => onSelect && onSelect(name)}
                  className={cls}
                  data-testid={`map-state-${name}`}
                  style={{
                    default: {
                      fill: COLORS[status],
                      stroke: isSel ? "#ffffff" : "#0A1128",
                      strokeWidth: isSel ? 1.6 : 0.6,
                      outline: "none",
                    },
                    hover: { fill: COLORS[status], stroke: "#ffffff", strokeWidth: 1.2, outline: "none" },
                    pressed: { fill: COLORS[status], outline: "none" },
                  }}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>

      <div className="flex items-center justify-center gap-6 mt-6 flex-wrap text-xs uppercase tracking-[0.15em]">
        <span className="flex items-center gap-2"><span className="w-3.5 h-3.5" style={{ background: COLORS.active }} /> Active Chapter</span>
        <span className="flex items-center gap-2"><span className="w-3.5 h-3.5 chapter-state-wanted" style={{ background: COLORS.wanted }} /> Leaders Wanted</span>
        <span className="flex items-center gap-2"><span className="w-3.5 h-3.5 border border-white/30" style={{ background: COLORS.none }} /> No Chapter Yet</span>
      </div>
    </div>
  );
};
